import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { DatabaseConnection } from '@definitions/database';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DatabaseConnectionsService } from '../services/database-connections.service';

export const databaseConnectionResolverFn = (
	route: ActivatedRouteSnapshot
): Observable<DatabaseConnection> => {
	const connectionsSvc = inject(DatabaseConnectionsService);
	const connectionId = route.paramMap.get('connectionId');

	return !isNaN(connectionId as any)
		? connectionsSvc.find(connectionId).pipe(catchError(() => of(null)))
		: of(null);
};
